// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Container for Drop Field
 */
import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import classnames from 'classnames';
import draggable from 'share/components/hoc/Izenda.Draggable';
import DnDReportPartFieldItemConfig from './Izenda.DnDReportPartFieldItemConfig';
import { DRAG_ITEM } from 'logic/data/Izenda.ReportBodyConstants';
import LayoutUtils from 'share/utils/Izenda.LayoutUtils';
import UiState from 'logic/Izenda.UiState';
import { exportClass } from 'share/Izenda.ServiceProvider';

import connect from 'share/enhancers/Izenda.Connect';
import Resizer from 'share/components/controls/Izenda.Resizer';

import localizer from 'share/localization/Izenda.Localizer';
import ReportPartFieldPropsContainerSchema from 'modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.ReportPartFieldPropsContainerSchema';
import action from './Izenda.FieldContainerAction';
import { isEmpty, flow, sortBy, get, compact, map } from 'lodash/fp';

const DraggableItem = draggable(DRAG_ITEM.REPORT_PART_FIELD_ITEM, DnDReportPartFieldItemConfig.sourceOptions);

const FieldItem = compose(DraggableItem)(require('./Izenda.FieldItem'));

const propsEditors = [
  {
    name: 'fieldProps',
    getDefinedSchema: ReportPartFieldPropsContainerSchema
  }
];

const FieldList = observer(props => {
  const {
    item,
    container,
    onDeleteElement,
    reportPart,
    store,
    isOver,
    showPlaceHolder,
    quickEdit,
    openSelectionFieldPopup,
    additionalClassName,
    canAccess
  } = props;

  const allowAccess = canAccess && canAccess(props, item);
  const haveField = !isEmpty(container.elements);

  const handleClick = () => LayoutUtils.togglePropertiesEditor(true);
  const setConfigField = element => () => reportPart.setConfigField(element);

  const fields = flow(
    get('elements'),
    sortBy('position'),
    map(
      elm =>
        elm ? (
          <FieldItem
            itemData={elm}
            container={container}
            onDeleteElement={onDeleteElement}
            onClick={handleClick}
            reportPart={reportPart}
            key={elm.position}
            store={store}
            fieldContainerDetails={container}
            propsEditors={propsEditors}
            beforeShowProps={setConfigField(elm)}
            isOverContainer={isOver}
          />
        ) : null
    ),
    compact
  )(container);

  const placeholder = showPlaceHolder && (
    <section className="u_textCenter">
      {!quickEdit && !UiState.isMobile && localizer.getText('REPORTDESIGNER_LABEL_DRAG_FIELD')}
      <a onClick={openSelectionFieldPopup}>{localizer.getText('REPORTDESIGNER_LABEL_ADD_NEW_FIELD')}</a>
    </section>
  );

  const fieldListClassName = classnames('input-drop-container form-control', additionalClassName, {
    'field-container': haveField,
    'can-drop': isOver && allowAccess,
    'cannot-drop': isOver && !allowAccess
  });

  return <div className={fieldListClassName}>{haveField ? fields : placeholder}</div>;
});

@exportClass('FieldContainer')
@connect(action)
export default class FieldContainer extends Component {
  static propTypes = {
    container: PropTypes.object,
    additionalClassName: PropTypes.string,
    reportPart: PropTypes.object,
    showPlaceHolder: PropTypes.bool,
    canAccess: PropTypes.func,
    openSelectionFieldPopup: PropTypes.func,
    store: PropTypes.object,
    isOver: PropTypes.bool
  };

  static defaultProps = {
    container: { elements: [] },
    additionalClassName: '',
    showPlaceHolder: true,
    height: 70,
    resizable: true,
    maximumField: null
  };

  render() {
    const { height, ...props } = this.props;
    const container = props.container;
    const store = this.props.store;

    const className = classnames('field-container-wrapper', props.additionalClassName);

    return (
      <div className={className}>
        <Resizer
          bottomRightResize
          bottomRightResizeClass="icon-drag"
          width="100%"
          height={height}
          minConstraints={[225, 70]}
        >
          <div>
            <div className="field-container-drag-resize">
              <FieldList {...props} />
              <a onClick={this.props.openSelectionFieldPopup}>
                <span className="field-container-icon field-container-icon-plus icon-plus" />
              </a>
            </div>
          </div>
        </Resizer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.FieldContainer.js